export function isLegacyReserveMachine(machine) {
  const status = machine && machine.registration_status;
  if (status === "reserve_available" || status === "reserve_in_use") {
    return true;
  }
  const ident = String((machine && machine.ident) || "")
    .trim()
    .toUpperCase();
  return (
    ident === "RESERVA" ||
    ident.startsWith("RESERVA-") ||
    ident.startsWith("RESERVA ")
  );
}
